export default {
  'components.cleanTextContextMenu.copy': '引用なしでテキストをコピー',
  'components.cleanTextContextMenu.copied': 'テキストをコピーしました',
  'components.cleanTextContextMenu.failed':
    'テキストをコピーできませんでした。もう一度お試しください。',
  'components.addToMattersPopover.selectMattersLabel': '案件を選択：',
  'components.addToMattersPopover.searchPlaceholder': '案件を検索...',
  'components.addToMattersPopover.updateSuccess': '案件を更新しました',
  'components.addToMattersPopover.updateError': '案件の更新に失敗しました',
  'components.billingRequiredOverlay.defaultMessage':
    'この操作を続行する前に、組織の請求情報の確認が必要です。組織の管理者にお問い合わせください。',
  'components.billingRequiredOverlay.title': '請求情報が必要です',
  'components.billingRequiredOverlay.manageBillingButton': '請求を管理',
  'components.chat.jsonResponseTitle': 'JSON レスポンス',
  'components.chat.dataOpenedInNewTab': 'データを新しいタブで開きました',
  'components.chat.textResponseTitle': 'テキストレスポンス',
  'components.chat.contentOpenedInNewTab': 'コンテンツを新しいタブで開きました',
  'components.chat.fileOpenedInNewTab': 'ファイルを新しいタブで開きました',
  'components.chat.failedToOpenNewTab': '新しいタブを開けませんでした',
  'components.chat.failedToFetchUrl': 'URL の取得に失敗しました：{message}',
  'components.chat.referenceDocumentFallback': '参照ドキュメント',
  'components.chat.sourcesCount': '出典（{count}）',
  'components.chat.referencesCount': '{count} 件の参照',
  'components.chat.htmlContentTitle': 'HTML コンテンツ',
  'components.chat.showMoreLines': 'さらに表示（{count} 行）',
  'components.chatWidget.waitingMessage.justAMoment': '少々お待ちください...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': '取得しています...',
  'components.chatWidget.waitingMessage.hangTight': '対応中です。もう少しお待ちください...',
  'components.chatWidget.waitingMessage.letMeCheck': '確認しています...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': 'すぐに終わります...',
  'components.chatWidget.closeChatAriaLabel': 'チャットを閉じる',
  'components.chatWidget.openChatAriaLabel': 'チャットを開く',
  'components.chatWidget.processingTooltip': '処理が完了するとチャットを利用できます',
  'components.chatWidget.messageCopied': 'メッセージをコピーしました',
  'components.chatWidget.copyMessageFailed': 'メッセージのコピーに失敗しました',
  'components.chatWidget.header.title': 'チャット',
  'components.chatWidget.emptyState.title': '何かお手伝いできることはありますか？',
  'components.chatWidget.inputPlaceholder': 'メッセージを入力...',
  'components.chatWidget.showMoreLines': 'さらに表示（{count} 行）',
  'components.chatWidget.invalidFileUrl': 'ファイル URL が無効または存在しません',
  'components.chatWidget.fileDownloadedSuccessfully': 'ファイルをダウンロードしました',
  'components.chatWidget.fileDownloadFailed': 'ファイルのダウンロードに失敗しました：{message}',
  'components.chatWidget.unnamedFile': 'ファイル',
  'components.chatWidget.attachmentImageAlt': '添付ファイル',
  'components.checklistCard.heading': 'チェックリスト',
  'components.downloadLoadingMask.downloading': 'ダウンロード中...',
  'components.emlViewer.fromLabel': '差出人：',
  'components.emlViewer.toLabel': '宛先：',
  'components.emlViewer.ccLabel': 'Cc：',
  'components.emlViewer.dateLabel': '日付：',
  'components.emlViewer.attachmentsLabel': '添付ファイル：',
  'components.filesSidePanel.favoritesButton': 'お気に入り',
  'components.filesSidePanel.historyButton': '履歴',
  'components.filesSidePanel.untitledPlaceholder': '（無題）',
  'components.filesSidePanel.membersPopoverTitle': 'メンバー',
  'components.filesSidePanel.ownerTag': 'オーナー',
  'components.filesSidePanel.modifyGroupTooltip': 'グループを変更',
  'components.filesSidePanel.privateGroupWarningTooltip':
    '安全性が低め：グループ内に公開されます。',
  'components.filesSidePanel.firmWideWarningTooltip': '非常に危険：事務所全体に公開されます。',
  'components.filesSidePanel.publicWarningTooltip': '非常に危険：全員に公開されます。',
  'components.filesSidePanel.sortByDateLabel': '日付順（新しい順）',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'アルファベット順（A-Z）',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'A&GEL Insider を開く',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': '新しいツールに慣れるには時間がかかります',
  'components.gettingStartedTour.insiderHero.basicsCard.copy':
    '初日から必要なものがすべて揃っています。',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': '基本から始める',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'さらに使いこなしたい方向けの強力な機能。',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': '詳しく見る',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy': '最近のリリースと更新情報。',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': '新着情報',
  'components.gettingStartedTour.insiderHero.marinaAlt': 'マリーナのスカイライン',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': '注目の記事',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'Grammar of Use',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'Grammar of Use という新しい形式の解説コンテンツを導入します。第 1 版は新規ユーザー向けの総合ガイドで、豊富な例と関連機能へのリンクを掲載しています',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'もっと見る',
  'components.gettingStartedTour.allCompleted.title': 'A&GEL ツアーをすべて完了しました！',
  'components.gettingStartedTour.allCompleted.redoButton': 'ツアーをやり直す',
  'components.gettingStartedTour.heading': 'はじめに',
  'components.gettingStartedTour.tourStyles.stepIndicator': 'ステップ {current} / {total}',
  'components.gettingStartedTour.tourStyles.nextDefault': '次へ →',
  'components.gettingStartedTour.chatTour.step1.title':
    'サンプルの NDA を読み込みました。「コンテキスト」をクリックして確認してください。',
  'components.gettingStartedTour.chatTour.step1.text':
    'ここで、A&GEL が回答時に参照するドキュメントを管理します。',
  'components.gettingStartedTour.chatTour.step2.title': '読み込まれたドキュメントです。',
  'components.gettingStartedTour.chatTour.step2.text':
    'ファイルをアップロードするか、ボールトから選択できます。準備ができたらパネルを閉じてください。',
  'components.gettingStartedTour.chatTour.step2.nextLabel': '閉じて続行 →',
  'components.gettingStartedTour.chatTour.step3.title':
    '質問をご用意しました。「送信」をクリックして NDA について尋ねてみましょう。',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'この契約における秘密保持義務はどのようなものですか？',
  'components.gettingStartedTour.chatTour.step4.title':
    '素晴らしい回答です！次に参照番号（例：[1]）をクリックして出典ドキュメントを確認しましょう。',
  'components.gettingStartedTour.chatTour.step4.text':
    '参照は、AI が使用したドキュメントの該当箇所に直接リンクしています。',
  'components.gettingStartedTour.chatTour.completeModal.title': 'お見事です！',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'チャットで最初の質問を行い、出典付きの回答を得られました。',
  'components.gettingStartedTour.tourComplete.progressText': '5 機能中 {completedCount} 件完了',
  'components.gettingStartedTour.tourComplete.completeButton': '完了',
  'components.gettingStartedTour.tourComplete.continueButton': '{title} に進む →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'よくできました！',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'ワークスタジオで修正を適用しました。',
  'components.gettingStartedTour.playbookTour.step1.title':
    '修正が必要なサンプルのベンダー契約書を読み込みました。',
  'components.gettingStartedTour.playbookTour.step1.text':
    'あなたはベンダー（Pand.ai）として、クライアントにより有利な条件を求めています。',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': '開いています…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'サンプルを開く →',
  'components.gettingStartedTour.playbookTour.step2.title': '3 件の修正依頼を作成しました：',
  'components.gettingStartedTour.playbookTour.step2.item1': '• 知的財産権の共有（第 17 条）',
  'components.gettingStartedTour.playbookTour.step2.item2': '• 14 日間の是正期間を追加（第 8 条）',
  'components.gettingStartedTour.playbookTour.step2.item3':
    '• 競業避止義務の範囲を限定（第 27 条）',
  'components.gettingStartedTour.playbookTour.step2.text':
    'マルチステップモードでは各項目を並行して処理し、より早く結果を得られます。',
  'components.gettingStartedTour.playbookTour.step3.title':
    '「送信」をクリックして修正案を生成しましょう。',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL が変更履歴を表示し、承認・却下・ダウンロードができます。',
  'components.gettingStartedTour.playbookTour.step4.title':
    'プロンプトから A&GEL が作成した修正案です。',
  'components.gettingStartedTour.playbookTour.step4.text':
    '各カードには元の文言と提案された変更が表示されます。',
  'components.gettingStartedTour.playbookTour.step5.title':
    'この修正案を確認して、承認または却下してください。',
  'components.gettingStartedTour.playbookTour.step5.text': '残りは後で同じように処理できます。',
  'components.gettingStartedTour.reviewTour.completeModal.title': '素晴らしい！',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    '質問リストを作成し、それを使ってドキュメントをレビューしました。',
  'components.gettingStartedTour.reviewTour.step1.title':
    'レビューでは、質問リストを使って複数のドキュメントから質問への回答を得られます。',
  'components.gettingStartedTour.reviewTour.step1.text':
    '独自に作成することも、既存のものを使うこともできます。',
  'components.gettingStartedTour.reviewTour.step2.title':
    'カテゴリ別に用意された質問リストを閲覧できます。',
  'components.gettingStartedTour.reviewTour.step3.title':
    '独自のリストを作成しましょう。ここをクリックして新しい質問リストを開始します。',
  'components.gettingStartedTour.reviewTour.step4.title':
    'リストを整理するカテゴリを選択してください。',
  'components.gettingStartedTour.reviewTour.step5.title':
    'サンプルの質問を、編集可能な行としてリストに追加しました。',
  'components.gettingStartedTour.reviewTour.step6.title':
    '質問は編集可能な行としてここに表示されます。いつでも削除でき、セクションを追加してグループ化することもできます。',
  'components.gettingStartedTour.reviewTour.step7.title':
    'このリストの目的を記述して、ご自身のニーズに合わせてください。',
  'components.gettingStartedTour.reviewTour.step8.title':
    'AI の回答方法（トーン、形式、詳細度）を調整できます。',
  'components.gettingStartedTour.reviewTour.step9.title':
    'リストを保存して、ドキュメントに使用しましょう。',
  'components.gettingStartedTour.reviewTour.step10.title':
    'お試しいただけるサンプルドキュメントを読み込みました。',
  'components.gettingStartedTour.reviewTour.step10.text': '質問リストを実行する準備が整いました。',
  'components.gettingStartedTour.reviewTour.step11.title':
    '「送信」を押して、すべてのドキュメントにレビューを実行しましょう。',
  'components.gettingStartedTour.reviewTour.step12.title':
    '各行が質問、各列がドキュメントです。回答は自動的に抽出されます。',
  'components.gettingStartedTour.reviewTour.step13.title':
    '任意の回答をクリックすると、その出典を正確に確認できます。',
  'components.gettingStartedTour.reviewTour.step14.title':
    '参照番号をクリックすると、出典ドキュメントの該当箇所に移動します。',
  'components.gettingStartedTour.reviewTour.step15.title':
    'これがレビューの一連の流れです。出典は常にワンクリックで確認できます。これで完了です！',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': '完了',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'よくできました！',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'スクライブで音声を文字起こししました。',
  'components.gettingStartedTour.scribeTour.step1.title': '文字起こしの用途を選択してください。',
  'components.gettingStartedTour.scribeTour.step1.text':
    'これにより A&GEL が出力形式を調整します。「議事録」がすでに選択されています。',
  'components.gettingStartedTour.scribeTour.step2.title': '言語は「自動検出」に設定されています。',
  'components.gettingStartedTour.scribeTour.step2.text':
    'リアルタイム翻訳を有効にして、翻訳をその場で確認することもできます。',
  'components.gettingStartedTour.scribeTour.step3.title':
    '録音ボタンをクリックするか、既存の音声ファイルをアップロードしてください。',
  'components.gettingStartedTour.scribeTour.step4.title':
    '文字起こしを保存する準備ができたら「停止」をクリックしてください。',
  'components.gettingStartedTour.scribeTour.step5.title':
    '文字起こしの名前を入力し、「保存」をクリックしてください。',
  'components.gettingStartedTour.scribeTour.step6.title':
    '文字起こしの任意の行をクリックすると、その箇所から音声を再生できます。',
  'components.gettingStartedTour.scribeTour.step7.title':
    '「編集」をクリックして文字起こしを修正できます。',
  'components.gettingStartedTour.scribeTour.step7.text': '変更箇所はゴールドで表示されます。',
  'components.gettingStartedTour.scribeTour.step8.title':
    '「保存」をクリックして変更を確定してください。',
  'components.gettingStartedTour.scribeTour.step8.text':
    '保存前の編集内容はゴールドで表示されます。',
  'components.gettingStartedTour.searchTour.completeModal.title': 'お見事です！',
  'components.gettingStartedTour.searchTour.completeModal.description':
    '複数のドキュメントを横断検索し、該当する条項を見つけました。',
  'components.gettingStartedTour.searchTour.step1.title': '検索クエリをご用意しました。',
  'components.gettingStartedTour.searchTour.step1.text':
    '「検索」をクリックするか Enter キーを押して、一致する条項を探しましょう。',
  'components.gettingStartedTour.searchTour.step2.title':
    'NDA からの一致結果です。ドキュメントをクリックすると、その中のすべての一致箇所を表示できます。',
  'components.gettingStartedTour.searchTour.step3.title':
    '任意のチャンクをクリックすると、ドキュメント内のそのセクションに移動します。',
  'components.gettingStartedTour.searchTour.step3.text':
    '左側には一致した抜粋が、右側にはキーワードがハイライトされたドキュメント全文が表示されます。',
  'components.gettingStartedTour.tourButton.label': 'ツアー',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'チャットで質問する',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'ドキュメントを横断検索する',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'スクライブで文字起こしする',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'レビューで分析する',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'ワークスタジオで修正を適用する',
  'components.gettingStartedTour.tourCompleteModal.title': '準備完了です！',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'A&GEL ツアーを完了し、次のことができるようになりました：',
  'components.gettingStartedTour.tourCompleteModal.progressText': '5 機能中 5 件完了',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'A&GEL を使い始める →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix':
    'お困りですか？こちらをご覧ください：',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'ユーザーガイド',
  'components.lLMMetrics.status.fast': '高速',
  'components.lLMMetrics.status.slow': '低速',
  'components.lLMMetrics.status.busy': '混雑',
  'components.lLMMetrics.status.pending': '保留中',
  'components.lLMMetrics.status.loading': '読み込み中',
  'components.lLMMetrics.metricBox.defaultChartLabel': '値',
  'components.management.passwordModal.usernameColumn': 'ユーザー名',
  'components.management.passwordModal.passwordColumn': 'パスワード',
  'components.management.passwordModal.createHeader': '以下の認証情報でユーザーを作成しました：',
  'components.management.passwordModal.emailChangeHeader':
    'ユーザーのメールアドレスを変更しました。新しい認証情報は以下のとおりです：',
  'components.management.passwordModal.changePasswordNotice':
    '※ユーザーは初回ログイン後にパスワードを変更する必要があります',
  'components.menuPanel.untitledItem': '（無題）',
  'components.menuPanel.renameFailed': '名前の変更に失敗しました',
  'components.menuPanel.deleteConfirm.title': '履歴項目を削除',
  'components.menuPanel.deleteConfirm.content':
    'この履歴項目を削除してもよろしいですか？この操作は元に戻せません。',
  'components.menuPanel.deleteConfirm.createdLabel': '作成日時：',
  'components.menuPanel.deleteSuccess': '履歴項目を削除しました',
  'components.menuPanel.deleteFailed': '履歴項目の削除に失敗しました',
  'components.menuPanel.searchHistoryButton': '履歴を検索',
  'components.menuPanel.historyLabel': '履歴',
  'components.menuPanel.showAllButton': 'すべて表示',
  'components.menuPanel.showFavoritesButton': 'お気に入りを表示',
  'components.menuPanel.endOfListMessage': '- これ以上はありません -',
  'components.message.enhanceGpt.modalTitle': 'GPT の回答を改善',
  'components.message.enhanceGpt.successMessage': '新しい回答を記録しました',
  'components.message.enhanceGpt.questionLabel': '質問：{question}',
  'components.message.enhanceGpt.answerLabel': '回答',
  'components.message.postback.clickedLabel': 'クリック：',
  'components.message.postback.chatbotButtonFallback': 'チャットボットボタン',
  'components.message.locationLabel': '位置情報',
  'components.message.stickerLabel': 'スタンプ',
  'components.message.audiosLabel': '音声',
  'components.message.imagesLabel': '画像',
  'components.message.videosLabel': '動画',
  'components.msgViewer.fromLabel': '差出人：',
  'components.msgViewer.toLabel': '宛先：',
  'components.msgViewer.attachmentsLabel': '添付ファイル：',
  'components.pdfViewerWithHighlight.renderError': 'PDF の表示に失敗しました',
  'components.promptSelector.copySuccess': 'プロンプトをコピーしました',
  'components.promptSelector.copyError': 'プロンプトのコピーに失敗しました',
  'components.promptSelector.noResultsFiltered': 'フィルター条件に一致するプロンプトがありません',
  'components.promptSelector.startTyping': '入力してプロンプトを検索してください',
  'components.promptSelector.promptLoaded': 'プロンプトをチャット入力欄に読み込みました',
  'components.promptSelector.untitledPrompt': '無題のプロンプト',
  'components.promptSelector.actionPlaceholder': 'アクション',
  'components.promptSelector.actionOption.summarise': '要約',
  'components.promptSelector.actionOption.review': 'レビュー',
  'components.promptSelector.actionOption.amend': '修正',
  'components.promptSelector.actionOption.draft': '起案',
  'components.promptSelector.actionOption.redFlagging': 'リスク抽出',
  'components.promptSelector.audiencePlaceholder': '公開範囲',
  'components.promptSelector.audienceOption.personal': '個人',
  'components.promptSelector.audienceOption.group': 'グループ',
  'components.promptSelector.audienceOption.public': '全体公開',
  'components.promptSelector.selectPromptHint': 'プロンプトを選択すると入力欄に読み込まれます',
  'components.promptSelector.usePromptButton': 'このプロンプトを使う',
  'components.promptSelector.authorLabel': '作成者',
  'components.promptSelector.promptLabel': 'プロンプト',
  'components.promptSelector.tagsLabel': 'タグ',
  'components.promptSelector.documentsAttached': '{count} 件のドキュメントが添付されます',
  'components.questionListSelection.untitledQuestionList': '（無題）',
  'components.questionListSelection.questionCount': '{count} 件の質問',
  'components.questionListSelection.accessPublicTag': '全体公開',
  'components.questionListSelection.accessFirmTag': '事務所',
  'components.questionListSelection.accessGroupTag': 'プライベートグループ',
  'components.questionListSelection.viewLess': '表示を減らす',
  'components.questionListSelection.viewAll': 'すべて表示',
  'components.questionListSelection.whatsNewButton': '新着情報',
  'components.questionListSelection.tourTooltip': 'ツアーを見る',
  'components.questionListSelection.tourButton': 'ツアー',
  'components.questionListSelection.sortMostPopular': '並べ替え：人気順',
  'components.questionListSelection.sortNameAsc': '並べ替え：名前 A-Z',
  'components.questionListSelection.sortNameDesc': '並べ替え：名前 Z-A',
  'components.questionListSelection.filterByAudiencePlaceholder': '公開範囲で絞り込む',
  'components.questionListSelection.audienceOptionPersonal': '個人',
  'components.questionListSelection.audienceOptionPublic': '全体公開',
  'components.questionListSelection.filterByAuthorPlaceholder': '作成者で絞り込む',
  'components.reference.unknownAuthor': '不明',
  'components.reference.timeAgo.justNow': 'たった今',
  'components.reference.timeAgo.minutesAgo': '{count, plural, other {# 分前}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, other {# 時間前}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, other {# 日前}}',
  'components.reference.openCellDetails': 'セルの詳細を開く',
  'components.reference.answerLabel': '回答：',
  'components.reference.explanationLabel': '説明',
  'components.reference.verifiedLabel': '検証済み',
  'components.reference.verifyLabel': '検証',
  'components.reference.pleaseEnterComment': 'コメントを入力してください',
  'components.reference.matrixIdRequired':
    'マトリックス ID が必要です。Reference コンポーネントに matrixId プロパティが渡されていることを確認してください。',
  'components.reference.commentAddedSuccess': 'コメントを追加しました',
  'components.reference.failedToAddComment': 'コメントの追加に失敗しました',
  'components.reference.commentUpdatedSuccess': 'コメントを更新しました',
  'components.reference.updateOwnCommentsOnly': '自分のコメントのみ更新できます',
  'components.reference.failedToUpdateComment': 'コメントの更新に失敗しました',
  'components.reference.commentDeletedSuccess': 'コメントを削除しました',
  'components.reference.deleteOwnCommentsOnly': '自分のコメントのみ削除できます',
  'components.reference.failedToDeleteComment': 'コメントの削除に失敗しました',
  'components.reference.deleteComment.title': 'コメントを削除',
  'components.reference.deleteComment.description': 'このコメントを削除してもよろしいですか？',
  'components.reference.addCommentPlaceholder': 'コメントを追加...',
  'components.reference.cellsSelected': '{count, plural, other {# 件のセルを選択中。}}',
  'components.reference.selectCellAriaLabel': 'セルを選択',
  'components.reference.selectQuestionRowAriaLabel': '質問の行を選択',
  'components.reference.selectDocumentColumnAriaLabel': 'ドキュメントの列を選択',
  'components.reference.selectDocumentRowAriaLabel': 'ドキュメントの行を選択',
  'components.reference.selectQuestionColumnAriaLabel': '質問の列を選択',
  'components.reference.documentsHeader': 'ドキュメント',
  'components.reference.addRow': '行を追加',
  'components.reference.addColumn': '列を追加',
  'components.reference.inverse': '行列を入れ替え',
  'components.reference.showAllColumns': 'すべての列を表示',
  'components.reference.showAllRows': 'すべての行を表示',
  'components.reference.resetView': '表示をリセット',
  'components.reference.summaryView': 'サマリー表示',
  'components.reference.detailedView': '詳細表示',
  'components.reference.exitSelectMode': '終了',
  'components.reference.chatWithSelectedOutput': '選択した出力についてチャットする',
  'components.reference.selectCells': 'セルを選択',
  'components.referencePopover.fileLinkUnavailable': 'ファイルリンクを利用できません',
  'components.referencePopover.failedToOpenNewTab': '新しいタブを開けませんでした',
  'components.referencePopover.failedToOpenFile': 'ファイルを開けませんでした',
  'components.referencePopover.openInNewTab': 'ドキュメントを新しいタブで開く ↗',
  'components.rightContent.organisationSwitcher.switching': '組織を切り替えています...',
  'components.rightContent.organisationSwitcher.switchSuccess': '組織を切り替えました',
  'components.rightContent.organisationSwitcher.switchNoToken':
    '組織の切り替えで新しいトークンが返されませんでした',
  'components.rightContent.organisationSwitcher.switchError': '組織の切り替えに失敗しました',
  'components.rightContent.organisationSwitcher.unknownOrg': '不明な組織',
  'components.rightContent.organisationSwitcher.defaultLabel': '組織',
  'components.rightContent.organisationSwitcher.tooltipFallback': '組織を切り替える',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': 'お問い合わせ',
  'components.rightContent.reportBug.label': 'バグを報告',
  'components.rightContent.reportBug.modalDescription':
    '発生した問題を以下のフォームにご記入ください。',
  'components.rightContent.reportBug.contactSectionTitle': '連絡先',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'バグの内容',
  'components.rightContent.reportBug.environmentSectionTitle': '環境',
  'components.rightContent.reportBug.namePlaceholder': 'お名前を入力してください',
  'components.rightContent.reportBug.nameRequired': 'お名前を入力してください',
  'components.rightContent.reportBug.emailLabel': 'メールアドレス',
  'components.rightContent.reportBug.emailPlaceholder': 'メールアドレスを入力してください',
  'components.rightContent.reportBug.emailRequired': 'メールアドレスを入力してください',
  'components.rightContent.reportBug.emailInvalid': '有効なメールアドレスを入力してください',
  'components.rightContent.reportBug.locationLabel': 'バグが発生した場所はどこですか？',
  'components.rightContent.reportBug.locationPlaceholder': '機能を選択',
  'components.rightContent.reportBug.locationRequired': 'バグが発生した場所を指定してください',
  'components.rightContent.reportBug.descriptionLabel': '問題の内容を記入してください',
  'components.rightContent.reportBug.descriptionRequired': '問題の内容を記入してください',
  'components.rightContent.reportBug.filesLabel': 'スクリーンショットまたは録画',
  'components.rightContent.reportBug.uploadText': 'クリックまたはドラッグしてアップロード',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.removeFile': '{fileName} を削除',
  'components.rightContent.reportBug.deviceLabel': 'デバイス',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'ご使用のデバイスを指定してください',
  'components.rightContent.reportBug.osLabel': 'OS とバージョン',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'ご使用の OS を指定してください',
  'components.rightContent.reportBug.browserLabel': 'ブラウザ',
  'components.rightContent.reportBug.browserPlaceholder': 'ブラウザを選択',
  'components.rightContent.reportBug.browserRequired': 'ご使用のブラウザを指定してください',
  'components.rightContent.reportBug.submitSuccess': 'バグ報告を送信しました',
  'components.rightContent.reportBug.submitError':
    'バグ報告の送信に失敗しました。もう一度お試しください。',
  'components.rightContent.reportBug.invalidFileType':
    '画像または動画ファイルのみアップロードできます',
  'components.rightContent.reportBug.fileUploadSuccess':
    'ファイル「{fileName}」をアップロードしました',
  'components.rightContent.reportBug.fileUploadError': 'ファイルのアップロードに失敗しました',
  'components.rightContent.reportBug.page.home': 'ホーム',
  'components.rightContent.reportBug.page.chat': 'チャット',
  'components.rightContent.reportBug.page.composer': 'コンポーザー',
  'components.rightContent.reportBug.page.review': 'レビュー',
  'components.rightContent.reportBug.page.reference': 'リファレンス',
  'components.rightContent.reportBug.page.files': 'ファイル',
  'components.rightContent.reportBug.page.userProfile': 'ユーザープロフィール',
  'components.rightContent.reportBug.page.other': 'その他',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': 'その他',
  'components.rightContent.receiptModal.title': 'ありがとうございます',
  'components.rightContent.receiptModal.description': 'ご報告を送信しました。',
  'components.scribe.clickToStartRecording': 'クリックして録音を開始',
  'components.scribe.failedToGetAuthToken': '認証トークンの取得に失敗しました',
  'components.scribe.failedToStartRecording': '録音の開始に失敗しました',
  'components.searchPdfViewerWithHighlight.renderError': 'PDF の表示に失敗しました',
  'components.themeToggle.themeSectionLabel': 'テーマ',
  'components.themeToggle.themeTeal': '🌊 ティール',
  'components.themeToggle.themeMaroon': '🍷 マルーン',
  'components.themeToggle.modeSectionLabel': 'モード',
  'components.themeToggle.lightMode': 'ライト',
  'components.themeToggle.darkMode': 'ダーク',
  'components.themeToggle.themeSettingsTooltip': 'テーマ設定',
  'components.whatsNewModal.title': '新着情報',
  'components.whatsNewModal.intro':
    'ドキュメントレビューをより快適にする新機能をいくつか追加しました：',
  'components.whatsNewModal.feature1.title': 'フィルター機能の改善：',
  'components.whatsNewModal.feature1.description':
    '公開範囲と作成者のフィルターが追加され、質問リストをより素早く見つけられます。',
  'components.whatsNewModal.feature2.title': 'アドホックな質問：',
  'components.whatsNewModal.feature2.description': 'その場で質問を追加できる、より柔軟な方法です。',
  'components.whatsNewModal.feature3.title': 'UI の改善：',
  'components.whatsNewModal.feature3.description':
    '{featureName} の管理がより直感的でシンプルなインターフェースになりました。',
  'components.whatsNewModal.upcomingFeatures.title': '今後の機能',
  'components.whatsNewModal.upcomingFeatures.description':
    '共同レビューや高度な AI 分析など、今後のアップデートにご期待ください。',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID をコピーしました',
  'components.file.manager.fetchGroupError': 'グループの取得に失敗しました：{message}',
  'components.file.manager.fetchFilesError': 'ファイルの取得に失敗しました：{message}',
  'components.file.manager.breadcrumbRoot': 'ルート',
  'components.file.manager.breadcrumbBackUpLevel': '一つ上の階層へ',
  'components.file.manager.searchPlaceholder': 'ファイルまたはフォルダを検索',
  'components.file.manager.uploadFileButton': 'ファイルをアップロード',
  'components.file.manager.createFolderButton': 'フォルダを作成',
  'components.file.manager.enterButton': '開く',
  'components.file.manager.deleteFolderButton': 'フォルダを削除',
  'components.file.manager.deleteFileButton': 'ファイルを削除',
  'components.file.manager.uploadedByTime':
    'アップロード者：{username}、アップロード日時：{createdAt}',
  'components.file.manager.folderNamePlaceholder': 'フォルダ名',
  'components.file.filePreview.cannotPreview': 'このファイル形式はプレビューできません',
  'components.file.documentSelector.sortNameAsc': '名前（A-Z）',
  'components.file.documentSelector.sortNameDesc': '名前（Z-A）',
  'components.file.documentSelector.sortNewestFirst': '新しい順',
  'components.file.documentSelector.sortOldestFirst': '古い順',
  'components.file.documentSelector.favourites': 'お気に入り',
  'components.file.documentSelector.selectedCount': '選択中（{count}）：',
  'components.file.documentSelector.selectAllFilesInFolder':
    '{folderName} 内のすべてのファイルを選択',
  'components.file.documentSelector.noFiles': 'ファイルがありません',
  'components.file.documentSelector.folderAlt': 'フォルダ',
  'components.file.documentSelector.fileAlt': 'ファイル',
  'components.file.documentSelector.selectDocuments': 'ドキュメントを選択',
  'components.file.documentSelector.selectOkText': '選択',
  'components.file.fileTree.uploadFailed': '{fileName} のアップロードに失敗しました',
  'components.file.fileTree.clickOrDragToUpload': 'クリックまたはドラッグしてアップロード',
  'components.file.fileTree.noFilesUploadedOrSelected':
    'アップロードまたは選択されたファイルはまだありません。',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'デフォルトのコンテキストは削除できません。先に別のコンテキストをデフォルトに設定してください。',
  'components.file.selectContext.contextDeleted': 'コンテキストを削除しました',
  'components.file.selectContext.deleteContextFailed': 'コンテキストの削除に失敗しました',
  'components.file.selectContext.enterContextNameWarning': 'コンテキスト名を入力してください',
  'components.file.selectContext.contextCreated': 'コンテキストを作成しました',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'デフォルトのコンテキストを解除することはできません。先に別のコンテキストをデフォルトに設定してください。',
  'components.file.selectContext.contextUpdated': 'コンテキストを更新しました',
  'components.file.selectContext.createContextFailed': 'コンテキストの作成に失敗しました',
  'components.file.selectContext.updateContextFailed': 'コンテキストの更新に失敗しました',
  'components.file.selectContext.selectContextPresetPlaceholder': 'コンテキストプリセットを選択',
  'components.file.selectContext.defaultLabel': '（デフォルト）',
  'components.file.selectContext.deleteContextConfirmTitle': 'このコンテキストを削除しますか？',
  'components.file.selectContext.deleteContextConfirmDescription': 'この操作は元に戻せません。',
  'components.file.selectContext.addNewContextTooltip': '新しいコンテキストを追加',
  'components.file.selectContext.modifyContextInfoTooltip': 'コンテキスト情報を編集',
  'components.file.selectContext.newContextLabel': '新しいコンテキスト',
  'components.file.selectContext.editContextLabel': 'コンテキストを編集',
  'components.file.selectContext.contextTitlePlaceholder': 'コンテキストのタイトル',
  'components.file.selectContext.setAsDefaultLabel': 'デフォルトに設定',
  'components.file.selectContext.contextSelectionTitle': 'コンテキストの選択',
  'components.file.selectContext.noContextSelected': 'コンテキストが選択されていません',
  'components.appShell.logoutMenuItem': 'ログアウト',
  'components.appShell.unauthorized.title': 'このページはご利用いただけません',
  'components.appShell.unauthorized.backHome': 'ホームに戻る',
  'components.appShell.promptLibrary.title': 'プロンプトライブラリ',
  'components.appShell.promptLibrary.noPromptsAvailable': '利用できるプロンプトがありません',
  'components.appShell.promptLibrary.copyTooltip': 'プロンプトの内容をコピー',
  'components.appShell.promptLibrary.untitledPrompt': '無題のプロンプト',
  'components.appShell.promptLibrary.copiedMessage': 'プロンプトをクリップボードにコピーしました',
  'components.appShell.clipboard.title': 'クリップボード',
  'components.appShell.clipboard.copiedMessage': 'コピーしました',
  'components.appShell.notFound.title': 'このページは存在しません',
  'components.gettingStartedTour.tourTask.chat.title': 'チャット',
  'components.gettingStartedTour.tourTask.chat.duration': '約 1 分',
  'components.gettingStartedTour.tourTask.search.title': '検索',
  'components.gettingStartedTour.tourTask.search.duration': '約 1 分',
  'components.gettingStartedTour.tourTask.scribe.title': 'スクライブ',
  'components.gettingStartedTour.tourTask.scribe.duration': '約 2 分',
  'components.gettingStartedTour.tourTask.review.title': 'レビュー',
  'components.gettingStartedTour.tourTask.review.duration': '約 3 分',
  'components.gettingStartedTour.tourTask.playbook.title': 'ワークスタジオ',
  'components.gettingStartedTour.tourTask.playbook.duration': '約 2 分',
  'components.matrixPolling.processingStoppedMessage': '処理を停止しました',
  'components.matrixPolling.stopProcessingFailedMessage': '処理の停止に失敗しました',
  'components.appShell.noResponseError': '応答がありません。もう一度お試しください。',
  'components.appShell.requestError': 'リクエストエラーが発生しました。もう一度お試しください。',
  'components.appShell.requestFailedError': 'リクエストに失敗しました',
  'components.composerService.socketErrorPrefix': 'エラー：{message}',
  'components.composerService.sessionDisconnected':
    '別の接続が確立されたため、コンポーザーのセッションが切断されました',
  'components.fileViewerWithToken.retrieveFailedError': 'ファイルの取得に失敗しました',
  'components.languageSwitcher.switchLanguageTooltip': '言語を切り替える',
  'components.crossOrgBadge.sharedByLabel': '共有元：{orgName}',
  'components.crossOrgBadge.externalOrganization': '外部組織',
  'components.file.sharePoint.fromComputer': 'このコンピューターから',
  'components.file.sharePoint.fromSharePoint': 'SharePoint / OneDrive から',
  'components.file.sharePoint.orAddFromSharePoint': 'または SharePoint / OneDrive から追加',
  'components.file.sharePoint.account': 'Microsoft アカウント',
  'components.file.sharePoint.useDifferentAccount': '別のアカウントを使用',
  'components.file.sharePoint.disconnect': '接続を解除',
  'components.file.sharePoint.disconnectConfirm':
    'Microsoft アカウントと A&GEL の接続を解除しますか？',
  'components.file.sharePoint.disconnected': 'Microsoft アカウントの接続を解除しました。',
  'components.file.sharePoint.popupBlocked':
    'SharePoint からファイルを選択するには、A&GEL のポップアップを許可してください。',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint へのアクセスが承認されていません',
  'components.file.sharePoint.consentDenied':
    'SharePoint へのアクセスが承認されませんでした。組織で IT 管理者の承認が必要な場合は、IT 管理者に A&GEL の承認を依頼してください。',
  'components.file.sharePoint.copyApprovalLink': 'IT 管理者用の承認リンクをコピー',
  'components.file.sharePoint.approvalLinkCopied': '承認リンクをコピーしました。',
  'components.file.sharePoint.connectFailed':
    'Microsoft に接続できませんでした。もう一度お試しください。',
  'components.file.sharePoint.reconnect': 'Microsoft アカウントを再接続してください。',
  'components.file.sharePoint.unsupportedType':
    '{name} はここではサポートされていないファイル形式です。',
  'components.file.sharePoint.tooLarge': '{name} は大きすぎます（最大 {max} MB）。',
  'components.file.sharePoint.rejected': '{name} を追加できませんでした。',
  'components.file.sharePoint.downloadFailed':
    'SharePoint から {name} を取得できませんでした。もう一度お試しいただくか、コンピューターからアップロードしてください。',
  'components.file.sharePoint.folderTooLarge':
    'このフォルダーは一度にインポートするには大きすぎます（最大 {max} ファイル）。より小さいフォルダーを選択してください。',
  'components.file.sharePoint.chooserTitle': 'ファイルの選択',
  'components.file.sharePoint.chooserMyFiles': 'マイ ファイル',
  'components.file.sharePoint.chooserShared': '共有',
  'components.file.sharePoint.chooserFollowedSites': 'フォロー中のサイト',
  'components.file.sharePoint.chooserSearch': 'サイトを検索',
  'components.file.sharePoint.chooserName': '名前',
  'components.file.sharePoint.chooserEmpty':
    'フォロー中のサイトはまだありません。上でサイトを検索してください。',
  'components.file.sharePoint.chooserLocked':
    'フォロー中または検索したサイトのみ表示されます。すべてのサイトを参照するには、IT 管理者に A&GEL の承認を依頼してください。',
  'components.file.sharePoint.chooserLoading': '読み込み中…',
  'components.file.sharePoint.chooserSelect': '選択',
  'components.file.sharePoint.chooserCancel': 'キャンセル',
};
